import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';
import styles from './SearchByCategpry.module.css';

import speechIcon from '../../Assets/icons/icon2.png';
import audioIcon from '../../Assets/icons/icon3.png';
import videoIcon from '../../Assets/icons/icon4.png';
import storyIcon from '../../Assets/icons/icon5.png';
import productionIcon from '../../Assets/icons/icon1.png';
import defaultImage from '../../Assets/speeches/v1_83.png';

const CategorySearchResults = () => {
  const { category, search } = useParams();
  // const location = useLocation();
  const navigate = useNavigate();
  
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [displayedCount, setDisplayedCount] = useState(10);
  const [totalResults, setTotalResults] = useState(0);

  const decodedSearch = decodeURIComponent(search || '');
  console.log(category)

  let PickLanguage = localStorage.getItem('siteLanguage')
  let categoryConfig;

  // Category configuration
  if( PickLanguage === "fa") {
    categoryConfig = {
    speeches: {
      name: 'بيانات',
      icon: speechIcon,
      color: '#1a5f3f',
      route: '/speeches',
      apiCategory: 'speech'
    },
    audios: {
      name: 'فایل‌های صوتی',
      icon: audioIcon,
      color: '#2d7a4d',
      route: '/audios',
      apiCategory: 'audio'
    },
    videos: {
      name: 'ویدیوها',
      icon: videoIcon,
      color: '#0f4229',
      route: '/videos',
      apiCategory: 'video'
    },
    videos: {
      name: 'داستان',
      icon: videoIcon,
      color: '#0f4229',
      route: '/stories',
      apiCategory: 'stories'
    },
    productions: {
      name: 'تولیدات',
      icon: productionIcon,
      color: '#1a5f3f',
      route: '/productions',
      apiCategory: 'production'
    }
  };
  }else {
    categoryConfig = {
    speeches: {
      name: 'خطابات',
      icon: speechIcon,
      color: '#1a5f3f',
      route: '/speeches',
      apiCategory: 'speech'
    },
    audios: {
      name: 'ملفات صوتیه',
      icon: audioIcon,
      color: '#2d7a4d',
      route: '/audios',
      apiCategory: 'audio'
    },
    videos: {
      name: 'فیدیوهات',
      icon: videoIcon,
      color: '#0f4229',
      route: '/videos',
      apiCategory: 'video'
    },
    productions: {
      name: 'انتاجات',
      icon: productionIcon,
      color: '#1a5f3f',
      route: '/productions',
      apiCategory: 'production'
    }
  };
  }

  const categoryInfo = categoryConfig[category] || categoryConfig.speeches;

  // Fetch search results
  useEffect(() => {
    const fetchCategorySearchResults = async () => {
      if (!decodedSearch.trim()) {
        setSearchResults([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `https://api.nasrollah.info/fa/?function=searchByCategory&params=${encodeURIComponent(decodedSearch)}&category=${categoryInfo.apiCategory}`
          
        );
        console.log(categoryInfo.apiCategory)

        if (!response.ok) {
          throw new Error(`خطا در دریافت نتایج جستجو برای ${categoryInfo.name}`);
        }

        const data = await response.json();
        
        // Sort results by date (newest first)
        const sortedResults = (data || []).sort((a, b) => 
          new Date(b.original_time_post) - new Date(a.original_time_post)
        );

        setSearchResults(sortedResults);
        setTotalResults(sortedResults.length);
      } catch (err) {
        console.error('Search error:', err);
        setError(err.message);
        setSearchResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategorySearchResults();
  }, [decodedSearch, category, categoryInfo.apiCategory]);

  // Helper functions
  const formatSlug = (slug) => {
    if (!slug) return '';
    return slug.replace(/\s+/g, '-');
  };

  const convertToPersianYear = (dateString) => {
    if (!dateString) return '';
    
    try {
      let date;
      
      if (dateString.includes('/')) {
        const parts = dateString.split('/');
        if (parts.length === 3) {
          const year = parts.find(part => part.length === 4);
          if (year) {
            date = new Date(parseInt(year), 0, 1);
          } else {
            date = new Date(dateString);
          }
        } else {
          date = new Date(dateString);
        }
      } else {
        date = new Date(dateString);
      }
      
      if (isNaN(date.getTime())) {
        const yearMatch = dateString.match(/\d{4}/);
        if (yearMatch) {
          date = new Date(parseInt(yearMatch[0]), 0, 1);
        } else {
          return '';
        }
      }
      
      const gregorianYear = date.getFullYear();
      const gregorianMonth = date.getMonth() + 1;
      const gregorianDay = date.getDate();
      
      let persianYear;
      
      if (gregorianMonth < 3 || (gregorianMonth === 3 && gregorianDay < 21)) {
        persianYear = gregorianYear - 622;
      } else {
        persianYear = gregorianYear - 621;
      }
      
      return persianYear.toString();
    } catch (error) {
      console.error('Error converting to Persian year:', error);
      return '';
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  // Event handlers
  const handleCardClick = (post) => {
    const formattedSlug = formatSlug(post.slug_post);
    const persianYear = convertToPersianYear(post.original_time_post);
    navigate(`${categoryInfo.route}/${persianYear}/${formattedSlug}/${post.id_post}`);
  };

  const handleLoadMore = () => {
    setDisplayedCount(prev => prev + 10);
  };

  const handleBackToAllResults = () => {
    navigate(`${categoryInfo.route}`);
  };

  const handleRetry = () => {
    setError(null);
    setLoading(true);
    // The useEffect will automatically re-run
  };

  // Loading state
  if (loading) {
    return (
      <div className={styles.searchContainer}>
        <div className={styles.loadingState}>
          <div className={styles.spinner}></div>
          <p>در حال جستجو در {categoryInfo.name}...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className={styles.searchContainer}>
        <div className={styles.errorState}>
          <div className={styles.errorIcon}>⚠️</div>
          <h2>خطا در جستجو</h2>
          <p>{error}</p>
          <button 
            onClick={handleRetry} 
            className={styles.retryButton}
          >
            تلاش مجدد
          </button>
        </div>
      </div>
    );
  } 

  let PickLanuage = localStorage.getItem("siteLanguage")
  if ( PickLanuage === "fa") {
    return (
    <div className={styles.searchContainer}>
      {/* Navigation Header */}
      <div className={styles.searchHeader}>
        <button 
          onClick={handleBackToAllResults}
          className={styles.backButton}
        >
          <span className={styles.backArrow}>←</span>
          بازگشت به همه نتایج
        </button>
        
        <h1 className={styles.searchTitle}>
          نتایج جستجو در{' '}
          <span 
            className={styles.categoryName}
            style={{ color: categoryInfo.color }}
          >
            {categoryInfo.name}
          </span>
        </h1>
        
        <div className={styles.searchSubtitle}>
          برای: <span className={styles.searchTerm}>"{decodedSearch}"</span>
        </div>
        
        <div className={styles.resultsCount}>
          {totalResults > 0 ? (
            <span>{totalResults} نتیجه یافت شد</span>
          ) : (
            <span>هیچ نتیجه‌ای یافت نشد</span>
          )}
        </div>
      </div>

      {/* Results Content */}
      {totalResults === 0 ? (
        <div className={styles.noResults}>
          <div className={styles.noResultsIcon}>🔍</div>
          <h3>نتیجه‌ای در {categoryInfo.name} یافت نشد</h3>
          <p>لطفاً با کلمات کلیدی دیگری جستجو کنید یا سایر دسته‌بندی‌ها را بررسی کنید</p>
          <button 
            onClick={handleBackToAllResults}
            className={styles.allCategoriesButton}
          >
            جستجو در همه دسته‌بندی‌ها
          </button>
        </div>
      ) : (
        <div className={styles.resultsSection}>
          {/* Category Header */}
          <div className={styles.categoryHeader}>
            <div className={styles.categoryTitle}>
              <img 
                src={categoryInfo.icon} 
                alt={categoryInfo.name}
                className={styles.categoryIcon}
              />
              <h2 style={{ color: categoryInfo.color }}>
                {categoryInfo.name}
              </h2>
              <span className={styles.categoryCount}>
                ({totalResults})
              </span>
            </div>
          </div>

          {/* Posts Grid */}
          <div className={styles.postsGrid}>
            {searchResults.slice(0, displayedCount).map((post) => (
              <div
                key={post.id_post}
                className={styles.postCard}
                onClick={() => handleCardClick(post)}
                style={{ '--category-color': categoryInfo.color }}
              >
                <div className={styles.postImageContainer}>
                  <img
                    src={post.featured_post}
                    alt={post.title_post}
                    className={styles.postImage}
                    onError={(e) => {
                      e.target.src = defaultImage;
                    }}
                  />
                  <div className={styles.postOverlay}>
                    <img
                      src={categoryInfo.icon}
                      alt={categoryInfo.name}
                      className={styles.postIcon}
                    />
                  </div>
                </div>

                <div className={styles.postContent}>
                  <h3 className={styles.postTitle}>
                    {post.title_post}
                  </h3>
                  
                  <div className={styles.postMeta}>
                    <span className={styles.postAuthor}>
                      {post.author_post}
                    </span>
                    <span className={styles.metaSeparator}>•</span>
                    <span className={styles.postDate}>
                      {formatDate(post.original_time_post)}
                    </span>
                  </div>

                  <div className={styles.postCategory}>
                    <span 
                      className={styles.categoryBadge}
                      style={{ backgroundColor: categoryInfo.color }}
                    >
                      {categoryInfo.name}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Load More Button */}
          {displayedCount < totalResults && (
            <div className={styles.loadMoreSection}>
              <button 
                onClick={handleLoadMore}
                className={styles.loadMoreButton}
                style={{ backgroundColor: categoryInfo.color }}
              >
                نمایش بیشتر
                <span className={styles.loadMoreArrow}>↓</span>
              </button>
              <div className={styles.loadMoreCount}>
                نمایش {Math.min(displayedCount, searchResults.length)} از {totalResults} نتیجه
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
  }else {
    return (
    <div className={styles.searchContainer}>
      {/* Navigation Header */}
      <div className={styles.searchHeader}>
        <button 
          onClick={handleBackToAllResults}
          className={styles.backButton}
        >
          <span className={styles.backArrow}>←</span>
          العودة إلى جميع النتائج
        </button>
        
        <h1 className={styles.searchTitle}>
          نتائج البحث في{' '}
          <span 
            className={styles.categoryName}
            style={{ color: categoryInfo.color }}
          >
            {categoryInfo.name}
          </span>
        </h1>
        
        <div className={styles.searchSubtitle}>
          عن: <span className={styles.searchTerm}>"{decodedSearch}"</span>
        </div>
        
        <div className={styles.resultsCount}>
          {totalResults > 0 ? (
            <span>تم العثور على {totalResults} نتيجة</span>
          ) : (
            <span>لم يتم العثور على أي نتائج</span>
          )}
        </div>
      </div>

      {/* Results Content */}
      {totalResults === 0 ? (
        <div className={styles.noResults}>
          <div className={styles.noResultsIcon}>🔍</div>
          <h3>لم يتم العثور على نتائج في {categoryInfo.name}</h3>
          <p>يرجى البحث بكلمات مفتاحية أخرى أو مراجعة الفئات الأخرى</p>
          <button 
            onClick={handleBackToAllResults}
            className={styles.allCategoriesButton}
          >
            البحث في جميع الفئات
          </button>
        </div>
      ) : (
        <div className={styles.resultsSection}>
          {/* Category Header */}
          <div className={styles.categoryHeader}>
            <div className={styles.categoryTitle}>
              <img 
                src={categoryInfo.icon} 
                alt={categoryInfo.name}
                className={styles.categoryIcon}
              />
              <h2 style={{ color: categoryInfo.color }}>
                {categoryInfo.name}
              </h2>
              <span className={styles.categoryCount}>
                ({totalResults})
              </span>
            </div>
          </div>

          {/* Posts Grid */}
          <div className={styles.postsGrid}>
            {searchResults.slice(0, displayedCount).map((post) => (
              <div
                key={post.id_post}
                className={styles.postCard}
                onClick={() => handleCardClick(post)}
                style={{ '--category-color': categoryInfo.color }}
              >
                <div className={styles.postImageContainer}>
                  <img
                    src={post.featured_media_post || defaultImage}
                    alt={post.title_post}
                    className={styles.postImage}
                    onError={(e) => {
                      e.target.src = defaultImage;
                    }}
                  />
                  <div className={styles.postOverlay}>
                    <img
                      src={categoryInfo.icon}
                      alt={categoryInfo.name}
                      className={styles.postIcon}
                    />
                  </div>
                </div>

                <div className={styles.postContent}>
                  <h3 className={styles.postTitle}>
                    {post.title_post}
                  </h3>
                  
                  <div className={styles.postMeta}>
                    <span className={styles.postAuthor}>
                      {post.author_post}
                    </span>
                    <span className={styles.metaSeparator}>•</span>
                    <span className={styles.postDate}>
                      {formatDate(post.original_time_post)}
                    </span>
                  </div>

                  <div className={styles.postCategory}>
                    <span 
                      className={styles.categoryBadge}
                      style={{ backgroundColor: categoryInfo.color }}
                    >
                      {categoryInfo.name}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Load More Button */}
          {displayedCount < totalResults && (
            <div className={styles.loadMoreSection}>
              <button 
                onClick={handleLoadMore}
                className={styles.loadMoreButton}
                style={{ backgroundColor: categoryInfo.color }}
              >
                عرض المزيد
                <span className={styles.loadMoreArrow}>↓</span>
              </button>
              <div className={styles.loadMoreCount}>
                عرض {Math.min(displayedCount, searchResults.length)} من {totalResults} نتيجة
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );

  }

};

export default CategorySearchResults;
